RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.DataFreshness = Marionette.ItemView.extend({
        template: '#shellDataFreshnessStatusTemplate',
        ui: {
            freshnessInfo: '.x-data-freshness-info',
            popovers: '[data-toggle="popover"]',
            reloadBtn: 'button'
        },
        events: {
            'click @ui.reloadBtn': 'onClick'
        },
        initialize: function () {
            const me = this;

            me.listenTo(RivalIQ.state.landscape, 'change:landscapeDataUpdateStatus', _.bind(me.render, me));
            me.listenTo(RivalIQ.state.landscape, 'change:postTagUpdateStatus', _.bind(me.render, me));
            me.listenTo(RivalIQ.state.landscape, 'change:postTagsAutoTagRulesInFlight', _.bind(me.render, me));
        },
        onRender: function () {
            const me = this;
            me.dataFreshnessState = App.utils.getDataFreshnessState();

            let showDataMessage = true;

            let dataMessage = `Social data ${_.escape(me.dataFreshnessState.socialDataAgeText)} old`;

            if (me.dataFreshnessState.postTagUpdateStatus === RivalIQ.data.DataUpdateStates.UPDATE_COMPLETE ||
                me.dataFreshnessState.updateInFlight ||
                me.dataFreshnessState.updateComplete) {
                showDataMessage = false;
            }

            if (me.dataFreshnessState.postTagUpdateStatus === RivalIQ.data.DataUpdateStates.UPDATE_IN_FLIGHT) {
                const postTagsAutoTagRulesInFlight = RivalIQ.state.landscape.get('postTagsAutoTagRulesInFlight');

                const postTagIds = _.map(postTagsAutoTagRulesInFlight, 'id');
                const postTagsById = _.keyBy(postTagsAutoTagRulesInFlight, 'id');
                dataMessage = Marionette.TemplateCache.get('#shellPostTagsInflightStatusTemplate')({
                    postTags: RivalIQ.postTags.utils.getPostTags(postTagIds, postTagsById, true)
                });
                showDataMessage = true;
            }

            if (showDataMessage) {
                me.ui.popovers.popover({
                    html: true,
                    content: dataMessage,
                    trigger: 'hover'
                });
            }
        },
        onClick: function () {
            window.location.reload(false);
        },
        templateHelpers: function () {
            const dataFreshnessState = App.utils.getDataFreshnessState();

            let dataFreshnessIcon = 'fa-check';
            let showReloadButton = false;
            let refreshStatus = null;

            if (dataFreshnessState.postTagUpdateStatus === RivalIQ.data.DataUpdateStates.UPDATE_IN_FLIGHT) {
                dataFreshnessIcon = 'fa-spinner fa-spin';
                refreshStatus = 'Updating Post Tags';
            } else if (dataFreshnessState.updateInFlight) {
                dataFreshnessIcon = 'fa-spinner fa-spin';
                refreshStatus = 'Refreshing data';
            } else if (dataFreshnessState.updateComplete) {
                showReloadButton = true;
                refreshStatus = 'Data refresh complete';
            } else if (dataFreshnessState.postTagUpdateStatus === RivalIQ.data.DataUpdateStates.UPDATE_COMPLETE) {
                showReloadButton = true;
                refreshStatus = 'Post tags applied';
            }

            return _.extend({
                dataFreshnessIcon: dataFreshnessIcon,
                showReloadButton: showReloadButton,
                refreshStatus: refreshStatus
            }, dataFreshnessState);
        }

    });

});
